import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type StoreType = {
  created_at: string;
  id: number;
  is_active: boolean;
  name: string;
  updated_at: string;
  pj_id: number;
};

export type StoresListResponseType = StoreType[];

export const useGetStoresList = (
  options: QueryOptions<StoresListResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<StoresListResponseType> => {
      const { data } =
        await api.get<ApiResponse<StoresListResponseType>>(`/store/list`);

      return data.data;
    },
    queryKey: ['stores'],
    ...options,
  });
